export interface HealthForceGoCoursesResponse {
  /**
   * @deprecated We do not use HFGo course data, and rely on Docebo data as a single source of truth
   */
  courses: HealthForceGoCourse[];
  doceboToken: string;
}

export interface HealthForceGoCourse {
  id: number;
  user_id: number;
}

export interface HealthForceGoSkillsResponse {
  skills: HealthForceGoSkill[];
}

export interface HealthForceGoSkill {
  id: number;
  name: string;
  description: string;
  hasSkill: boolean;
  expiryDate: string | null;
  lmsCourseIds?: number[];
  lmsLearningPlanIds?: string[];
}

export default class HealthForceGoAPI {
  private static singleton: HealthForceGoAPI | null = null;

  private endpoint = `https://uats.healthforcego.com/v1.5/`;

  private token!: string;

  public static get instance(): HealthForceGoAPI {
    if (!HealthForceGoAPI.singleton) {
      HealthForceGoAPI.singleton = new HealthForceGoAPI();
    }
    return HealthForceGoAPI.singleton;
  }

  public setEnvironment(environment: string) {
    this.endpoint = `https://${environment}.healthforcego.com/v1.5/`;
  }

  public setToken(token: string) {
    this.token = token;
  }

  public getCourseData(): Promise<HealthForceGoCoursesResponse> {
    return this.request('lms/course') as Promise<HealthForceGoCoursesResponse>;
  }

  public getSkillsData(): Promise<HealthForceGoSkillsResponse> {
    return this.request('skill') as Promise<HealthForceGoSkillsResponse>;
  }

  private request(path: string): Promise<unknown> {
    if (!this.token)
      return Promise.reject(
        new Error('No access token, call setToken first to perform requests.')
      );
    return fetch(`${this.endpoint}${path}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    }).then((response) => {
      if (response.status === 200) return response.json();
      return response.json().then((error) => Promise.reject(error));
    });
  }
}
